import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
export default function clipboard(state, action) {
    var _a, _b;
    if (state === void 0) { state = {}; }
    if (action.type === actionTypes.SHOW_COPYING) {
        var target = action.target;
        return update(state, { $merge: (_a = {}, _a[target] = true, _a) });
    }
    if (action.type === actionTypes.SHOW_COPYING_DONE) {
        var target = action.target;
        return update(state, { $merge: (_b = {}, _b[target] = false, _b) });
    }
    return state;
}
